export default "<% if (previous_model) { %>\n    <div class=\"previous\"></div>\n<% } %>\n<% if (next_model) { %>\n    <div class=\"next\"></div>\n<% } %>";